import Accordion from '../../../../../shared/Accordion';
import PersonalFields from './PersonalFields';
import LocationFields from './LocationFields';
import ContactFields from './ContactFields';
import StageField from './StageField';

const General = ({
  open,
  onToggle,
  editable,
  formDataUser,
  handleChange,
  handleCityChange,
  typeIds,
  countries,
  cities,
  mode,
  loading,
}) => {
  return (
    <Accordion
      id="info-general"
      title="Información general"
      open={open}
      onToggle={onToggle}
      edit={editable}
    >
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <PersonalFields
          formDataUser={formDataUser}
          handleChange={handleChange}
          typeIds={typeIds}
          mode={mode}
          loading={loading}
          editable={editable}
        />
        <LocationFields
          formDataUser={formDataUser}
          handleChange={handleChange}
          handleCityChange={handleCityChange}
          countries={countries}
          cities={cities}
          editable={editable}
        />
        <ContactFields
          formDataUser={formDataUser}
          handleChange={handleChange}
          mode={mode}
          loading={loading}
          editable={editable}
        />
      </div>
      <StageField
        formDataUser={formDataUser}
        handleChange={handleChange}
        editable={editable}
      />
    </Accordion>
  );
};

export default General;
